import { useCallback, useEffect, useState } from 'react';
import { loadDeliveryState } from '../services/verseDeliveryService';

const emptyState = { subscriptions: [], deliveries: [] };

export default function useDeliveryState() {
  const [state, setState] = useState(emptyState);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const reload = useCallback(async ({ force = true } = {}) => {
    setLoading(true);
    setError('');
    try {
      const next = await loadDeliveryState({ force });
      setState(next);
      return next;
    } catch (loadError) {
      setError(loadError.message || 'Your delivery schedule could not be loaded.');
      throw loadError;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    loadDeliveryState()
      .then((next) => {
        if (mounted) setState(next);
      })
      .catch((loadError) => {
        if (mounted) setError(loadError.message || 'Your delivery schedule could not be loaded.');
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => { mounted = false; };
  }, []);

  return { ...state, loading, error, setState, reload };
}
